import React from 'react';
import { MultiSelect } from '@blueprintnyc/bpnyc-common-admin';

const EventGroupsPicker = props => {
	const { groups, targetKeys, handleChange } = props;

	const handleDelete = id => {
		if (id && handleChange) {
			// unnecessarily complicated handleChanges from various parents (can be simplified)
			handleChange('left', {
				selRightIDs: [id],
				rightIDs: [...targetKeys].filter(record => record !== id),
			});
		}
	};

	const handleAdd = id => {
		if (id && handleChange) {
			// unnecessarily complicated handleChanges from various parents (can be simplified)
			handleChange('right', { selLeftIDs: [id], rightIDs: [...targetKeys, id] });
		}
	};
	return (
		<MultiSelect
			selected={targetKeys}
			allOptions={groups}
			onDelete={handleDelete}
			onAdd={handleAdd}
		/>
	);
};

export default EventGroupsPicker;
